export default "__VITE_ASSET__D_a8L3mO__"